import React, { useState, useEffect, memo } from 'react';
import { Formik, Form } from 'formik';
import _ from 'lodash';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
import {
  uploadDocCAM,
  uploadedDocCAM,
  UploadFileToS3,
  CAMgetAPI,
  CAMApproveDoc,
  CAMRejectDoc
} from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import ShowGetImage from '../../../common/components/ShowGetImage/ShowGetImage';

import RejectReasonModal from '../../../common/components/RejectReasonModal/RejectReasonModal';
import CommonBtn from '../../LeadProfile/CommonBtn/CommonBtn';
import { getAcl } from '../../../common/utils/acl-utils';

const CAM = () => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const [dontClose, setDontClose] = useState(true);
  const [CAMDocId, setCAMDocId] = useState('');
  const [getResponse, setResponse] = useState(false);
  const [CAMstatus, setCAMStatus] = useState();
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReasonMsg, setRejectResonMsg] = useState('');
  const [isError, setError] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Formik
      initialValues={{
        isEditMode: false,
        file: [],
        imgUrl: []
      }}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        setValues
      }) => {
        //upload
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);
          await uploadDocCAM(getApplicantionInfo().leadId, 'cm-report/cam')
            .then(res => {
              setCAMDocId(res?.requestId);
              UploadFileToS3(res.url, values.file[0][0]).then(() => {
                uploadedDocCAM(
                  getApplicantionInfo().leadId,
                  'cm-report/cam',
                  res?.requestId
                ).then(res => {
                  setType('success');
                  setText('Uploaded the File successfully.');
                  setShow(true);
                  setDontClose(false);
                });
              });
            })
            .catch(err => {
              setShow(false);
            });
        }

        function getfun() {
          setType('loading');
          setText('Please wait while retrieving data...');
          setShow(true);
          setDontClose(true);

          CAMgetAPI(getApplicantionInfo().leadId)
            .then(res => {
              if (res?.links[0]) {
                setResponse(true);
              }
              setCAMStatus(res?.links[0]?.status);
              setImgLinkData(res?.links[0]?.url);
              setCAMDocId(res?.links[0]?.docId);
              setValues({
                ...values,
                isEditMode: res?.links[0]?.url ? true : false
              });

              setShow(false);
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
            });
        }

        useEffect(() => {
          getfun();
        }, []);

        // approved API
        const approveDocFun = docId => {
          setType('loading');
          setText('loading...');
          setShow(true);
          setDontClose(true);
          CAMApproveDoc(getApplicantionInfo().leadId, docId)
            .then(res => {
              getfun();
              setTimeout(() => {
                setShow(false);
              }, 2000);
              setType('success');
              setText('Approved  the File successfully.');
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
            });
        };

        // reject API
        const rejectDocFun = (docId, rejectReasonMsg) => {
          setType('loading');
          setText('loading...');
          setShow(true);
          setDontClose(true);
          CAMRejectDoc(getApplicantionInfo().leadId, docId, rejectReasonMsg)
            .then(res => {
              getfun();
              setShowRejectModal(false);
              setTimeout(() => {
                setShow(false);
              }, 2000);
              setType('success');
              setText('Rejected successfully.');
              setDontClose(false);
            })
            .catch(err => {
              setShow(false);
            });
        };
        const showApproveLayer = imgLinkData && !Edit1;

        useEffect(() => {
          if (rejectReasonMsg && rejectReasonMsg.length > 4) {
            return setError(false);
          } else {
            setErrorMessage('Required minimum 5 character');
            setError(true);
          }
        }, [rejectReasonMsg]);
        return (
          <React.Fragment>
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 px-7 sm:px-5 bg-white mt-5 ml-4 mr-7 pb-12 rounded
               w-full md:w-7/12"
              style={{
                border: '1px solid #e0dada'
              }}
            >
              <>
                <div className="mt-10 flex items-center flex-col">
                  <p className="font-medium mb-3 items-baseline text-base">
                    Upload Document
                  </p>
                  <div
                    className="bg-white  flex justify-center rounded-lg border border-navy-200 md:border-none
                        py-9  pr-5 pl-8  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
                  >
                    {imgLinkData && !Edit1 ? (
                      <div className="">
                        <ShowGetImage
                          img={imgLinkData}
                          setEdit={setEdit1}
                          showInPopUP={true}
                        />
                      </div>
                    ) : (
                      <GlobalUploadComp
                        data={values}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        initialImg={initialImg}
                        subInst="Click here or drop here to upload"
                        subtext="Upload File"
                      />
                    )}
                  </div>
                </div>
                {values?.file.length == 1 && values?.file[0] && (
                  <button
                    type="submit"
                    onClick={() => {
                      if (values.file[0] && values.file[0][0]) {
                        fileUpload();
                      }
                    }}
                    className={
                      'submitButton text-14 w-56 h-12 font-medium  font-roboto'
                    }
                  >
                    Upload and Send for Review
                  </button>
                )}

                {getAcl()?.acl?.is_credit_head &&
                  getResponse &&
                  showApproveLayer && (
                    <>
                      {(CAMstatus == 'UPLOADED' || !CAMstatus) && (
                        <div className={` flex justify-end mt-7`}>
                          <CommonBtn
                            value="Reject"
                            stylesBtn={{
                              backgroundColor: 'white',
                              color: '#FD4F60',
                              padding: '14px',
                              borderColor: '#FD4F60',
                              border: '1px solid',
                              width: '7rem',
                              textAlign: 'center',
                              display: 'block'
                            }}
                            onClick={() => {
                              setShowRejectModal(true);
                            }}
                          />
                          <CommonBtn
                            value="Approve"
                            stylesBtn={{
                              backgroundColor: '#00ACB8',
                              color: 'white',
                              padding: '14px',
                              border: '1px solid',
                              width: '7rem',
                              textAlign: 'center',
                              display: 'block'
                            }}
                            onClick={() => {
                              approveDocFun(CAMDocId);
                            }}
                          />
                        </div>
                      )}
                      {(CAMstatus == 'REJECTED' || CAMstatus == 'APPROVED') && (
                        <div className="flex justify-end pr-4">
                          <span
                            className={`${
                              CAMstatus === 'APPROVED'
                                ? 'text-green-paleGreen bg-green-thinGreen'
                                : 'text-red-200 bg-red-600'
                            } 
                                font-roboto font-normal px-2 text-xs  items-center rounded `}
                          >
                            {CAMstatus == 'APPROVED'
                              ? 'Approved'
                              : 'Not Approved'}
                          </span>
                          <span
                            onClick={() => {
                              setCAMStatus();
                            }}
                            className="text-orange-1100 font-roboto font-norma ml-1 items-center text-xs cursor-pointer"
                          >
                            Undo
                          </span>
                        </div>
                      )}
                    </>
                  )}
                <RejectReasonModal
                  showRejectModal={showRejectModal}
                  setShowRejectModal={setShowRejectModal}
                  rejectReasonMsg={rejectReasonMsg}
                  setRejectResonMsg={setRejectResonMsg}
                  errorMessage={errorMessage}
                  isError={isError}
                  docId={CAMDocId}
                  rejectDocFun={rejectDocFun}
                />
              </>
            </Form>

            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={dontClose}
              autoClose={type === 'success'}
            />
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default memo(withErrorHandler(CAM));
